import {Modal} from 'bootstrap/js/dist/modal';
window.Modal = Modal;
import WOW from 'wow.js';
window.WOW = WOW; // make it globally available for scripts.js

import './scripts.js';

export default{
  Modal
}


